import { Button, Modal, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { COMMON_ERROR } from '../../../../shared/constants/commonConstants';
import { RootState } from '../../../../store';
import { setUploadedFiles } from '../../../../store/actions/newAdmissionAction';
import { showIRModal, submitReimbursementIr } from '../../../../store/actions/reimbursementAction';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { IReimbursementState } from '../../../../store/models/reimbursementModel';
import { centeredNotification } from '../../../../utils/utility';
import FileUploader from './FileUploader';

const DetailRightAction = ({ form }: any): ReactElement => {
  const { irModalVisible, reimbursementDetail } = useSelector((state: RootState): IReimbursementState => state?.reimbursement || {});
  const {
    uploadedFiles: fileList,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { isRIquery } = reimbursementDetail || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const moveToEdit = (): any => {
    dispatch(showIRModal(true));
  };

  const onCancelModal = (): any => {
    dispatch(setUploadedFiles(fileList?.filter((ele: any): any => ele?.existingRecord)));
    dispatch(showIRModal(false));
  };

  const onSubmit = (): any => {
    setIsLoading(true);
    dispatch(submitReimbursementIr(form, onSuccess, onError));
  };

  const onSuccess = (): any => {
    dispatch(showIRModal(false));
    setIsLoading(false);
    centeredNotification('Payer query has been responded successfully!', 'success');
    history.push(`/reimbursement/home/`);
  };

  const onError = (err: any): any => {
    setIsLoading(false);
    centeredNotification(err || COMMON_ERROR);
  };

  return (
    <div>
      <Row justify="end">
        {
          isRIquery &&
          <div>
            <Button type="primary" onClick={moveToEdit}>Query reply</Button>
          </div>
        }
      </Row>
      <Modal
        onCancel={onCancelModal}
        maskClosable={false}
        width={800}
        title="Upload file"
        visible={irModalVisible}
        footer={[
          <Button key="cancel" onClick={onCancelModal}>Cancel</Button>,
          <Button key="submit" type="primary" onClick={onSubmit} loading={isLoading}>Submit</Button>,
        ]}
      >
        <FileUploader />
      </Modal>
    </div>
  );
};

export default DetailRightAction;
